import React from 'react';
import { cn } from '../../lib/utils';

/** Connector between funnel stages — makes drop-off glanceable. */
export function FunnelDropConnector({
  label,
  count,
  isWorst = false,
  className,
}) {
  if (!count && !label) return null;

  return (
    <div
      className={cn(
        'flex items-center gap-3 px-4 py-1 sm:px-6',
        className
      )}
      aria-hidden="true"
    >
      <div className="flex w-8 flex-col items-center">
        <div
          className={cn(
            'h-3 w-px',
            isWorst ? 'bg-rose-400' : 'bg-slate-300'
          )}
        />
        <div
          className={cn(
            'h-1.5 w-1.5 rounded-full',
            isWorst ? 'bg-rose-500' : 'bg-slate-400'
          )}
        />
        <div
          className={cn(
            'h-3 w-px',
            isWorst ? 'bg-rose-400' : 'bg-slate-300'
          )}
        />
      </div>
      <span
        className={cn(
          'rounded-full px-2.5 py-0.5 text-[11px] font-semibold tabular-nums',
          isWorst
            ? 'bg-rose-50 text-rose-700'
            : 'bg-slate-100 text-slate-600'
        )}
      >
        {label || `−${Number(count).toLocaleString('en-US')} dropped`}
      </span>
    </div>
  );
}
